import {DEFAULT_PAGE_SIZE} from 'plugins/modules/pagination/constants';
import {PaginationUrlService} from 'plugins/modules/pagination/services/PaginationUrlService';

export const getPageFromQuery = (searchQuery: URLSearchParams) =>
    Number(searchQuery.get(PaginationUrlService.COMMON_PARAM_NAMES.PAGE.toString())) || 1;

export const getPageSizeFromQuery = (searchQuery: URLSearchParams) =>
    Number(searchQuery.get(PaginationUrlService.COMMON_PARAM_NAMES.LIMIT.toString())) || DEFAULT_PAGE_SIZE;
